<template>
  <v-row
    justify="center"
    no-gutters
  >
    <v-col
      cols="12"
      sm="12"
      md="4"
      align-self="center"
      justify-self="center"
    >
      <v-card
        flat
        style="background-color: transparent;"
      >
        <v-card-title class="mb-5">
          <div>
            <h2 class="font-weight-thin">
              Relief
            </h2>
            <span class="login-title">Spa & Massage</span>
          </div>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="email"
            label="อีเมล"
            filled
            color="orange"
          />
          <v-text-field
            v-model="password"
            type="password"
            label="รหัสผ่าน"
            filled
            color="orange"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="orange"
            large
            @click="login"
          >
            เข้าสู่ระบบ
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-btn
        text
        @click="$router.push('/admin/login')"
      >
        หน้าสำหรับ admin
      </v-btn>
    </v-col>
    <v-col
      md="8"
    >
      <img
        class="login-img"
        src="@/assets/login.jpg"
      >
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex';
import http from '@/http';
import { SET_USER } from '@/store/mutation_types';

export default {
  name: 'CustomerLogin',
  data() {
    return {
      email: '',
      password: '',
      error: false,
      errorMessage: '',
    };
  },
  methods: {
    ...mapActions([SET_USER]),
    async login() {
      try {
        const user = await http.post('/auth/customer', {
          email: this.email,
          password: this.password,
        });
        this.SET_USER(user.data);
        this.$router.push('/customer/profile');
      } catch (err) {
        this.error = true;
        this.errorMessage = err;
      }
    },
  },
};
</script>

<style>
.login-title {
  font-family: 'Cinzel', serif;
  font-weight: 600;
  margin-left: 1.5em;
}
.login-img {
  background-size: cover;
  height: 100%;
  width: 100%;
}
</style>
